import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBezierCurves1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bezier-curves, path"><path d="M21 4.75C10 4.75 14 19.25 3 19.25" stroke="currentColor" strokeWidth="1.5"/><circle cx="4.75" cy="4.75" r="1.75" fill="currentColor"/><circle cx="19.25" cy="19.25" r="1.75" fill="currentColor"/><path d="M15 19.25H19" stroke="currentColor" strokeWidth="1.5"/><path d="M5 4.75H9" stroke="currentColor" strokeWidth="1.5"/><path d="M11 4.75H14" stroke="currentColor" strokeWidth="1.5"/><path d="M10 19.25H13" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconBezierCurves1;
